var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "axSidebar", staticClass: "ax-sidebar" },
    [
      _vm.isSidebarOpen
        ? _c("div", {
            staticClass: "sidebar-backdrop",
            on: { click: _vm.closeSidebar }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "SlidingPanel",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isSidebarOpen,
              expression: "isSidebarOpen"
            }
          ],
          ref: "SidebarPanel",
          staticClass: "ax-sidebar__panel",
          attrs: {
            id: "SidebarPanel",
            enterFrom: "left",
            isFullHeight: true,
            panelWidth: "270"
          }
        },
        [
          _c("div", { staticClass: "ax-sidebar__top" }, [
            _c("div", { staticClass: "ax-sidebar__logo-container" }, [
              _c("div", { staticClass: "ax-sidebar__logo-wrapper" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      target: "_blank",
                      rel: "noopener noreferrer",
                      href: "https://mria.nowinfinity.com.au/#/login"
                    }
                  },
                  [_c("now-infinity-logo")],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _vm.cloudOffisEnabled
              ? _c("div", { staticClass: "ax-sidebar__logo-container" }, [
                  _c("div", { staticClass: "ax-sidebar__logo-wrapper" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          id: "cloudoffis-logo",
                          target: "_blank",
                          href: _vm.cloudOffisUrl,
                          title: "cloudoffis Logo"
                        }
                      },
                      [_c("cloudoffis-logo")],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.enableDapSso
              ? _c("div", { staticClass: "ax-sidebar__logo-container" }, [
                  _c("div", { staticClass: "ax-sidebar__logo-wrapper" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          id: "dap-logo",
                          target: "_blank",
                          href: "/my/hub24_dap_sso",
                          title: "dap Logo"
                        }
                      },
                      [_c("dap-logo")],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.myProsperityEnabled
              ? _c("div", { staticClass: "ax-sidebar__logo-container" }, [
                  _c("div", { staticClass: "ax-sidebar__logo-wrapper" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          id: "myprosperity-logo",
                          target: "_blank",
                          href: _vm.myProsperityUrl,
                          title: "MyProsperity Logo"
                        }
                      },
                      [_c("myProsperity-logo")],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.virtualMainRoomEnabled
              ? _c("div", { staticClass: "ax-sidebar__logo-container" }, [
                  _c("div", { staticClass: "ax-sidebar__logo-wrapper" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          id: "vmr-logo",
                          target: "_blank",
                          href: _vm.virtualMainRoomUrl,
                          title: "Virtual Mailroom Logo"
                        }
                      },
                      [_c("vmr-logo")],
                      1
                    )
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ax-sidebar__middle" }),
          _vm._v(" "),
          _c("div", { staticClass: "ax-sidebar__bottom" }, [
            _c("div", { staticClass: "title-container" }, [
              _c("p", { staticClass: "ax-sidebar__links-group-heading" }, [
                _vm._v("Class Ltd")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "link-container" }, [
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    rel: "noopener noreferrer",
                    href: "https://www.class.com.au/about-us/"
                  }
                },
                [_vm._v("About us")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "link-container" }, [
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    rel: "noopener noreferrer",
                    href: "https://www.class.com.au/contact-us/"
                  }
                },
                [_vm._v("Contact us")]
              )
            ]),
            _vm._v(" "),
            _c("hr", { staticClass: "seperation-line" }),
            _vm._v(" "),
            _c("div", { staticClass: "title-container" }, [
              _c("p", { staticClass: "ax-sidebar__links-group-heading" }, [
                _vm._v("Legal documents")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "link-container" }, [
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    rel: "noopener noreferrer",
                    href: "https://www.class.com.au/class-privacy-policy/"
                  }
                },
                [_vm._v("Privacy policy")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "link-container" }, [
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    rel: "noopener noreferrer",
                    href: "https://www.class.com.au/eula/"
                  }
                },
                [_vm._v("End user licence agreement")]
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }